export enum FormErrorEnum {
    DQE = 'DQE',
    sameEmail = 'sameEmail',
    file = 'file'
}